// Per-environment settings of the container image: /config.js (generated at start by
// docker/40-cyrclo-config.sh) sets window.__CYRCLO_CONFIG__ before the app loads. Locally and in
// tests it is absent and readers fall back to the build-time process.env.NEXT_PUBLIC_*.
export type RuntimeConfig = {
  privyAppId?: string
  privyClientId?: string
  apiUrl?: string
  cyrclotechUrl?: string
}

declare global {
  interface Window {
    __CYRCLO_CONFIG__?: RuntimeConfig
  }
}

export function runtimeConfig(): RuntimeConfig {
  return (typeof window === "undefined" ? undefined : window.__CYRCLO_CONFIG__) ?? {}
}
